const actions = {
    PUBLIC_STATEMENT_READ_REQUEST: 'PUBLIC_STATEMENT_READ_REQUEST',
    PUBLIC_STATEMENT_READ_SUCCESS: 'PUBLIC_STATEMENT_READ_SUCCESS',
    PUBLIC_STATEMENT_READ_ERROR: 'PUBLIC_STATEMENT_READ_ERROR',
    PUBLIC_STATEMENT_READ_V2_REQUEST: 'PUBLIC_STATEMENT_READ_V2_REQUEST',
    PUBLIC_STATEMENT_READ_V2_SUCCESS: 'PUBLIC_STATEMENT_READ_V2_SUCCESS',
    PUBLIC_STATEMENT_READ_V2_ERROR: 'PUBLIC_STATEMENT_READ_V2_ERROR',
    PUBLIC_STATEMENT_RESET_STATE: 'PUBLIC_STATEMENT_RESET_STATE',
    PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_REQUEST: 'PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_REQUEST',
    PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_SUCCESS: 'PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_SUCCESS',
    PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_ERROR: 'PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_ERROR',
    PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_REQUEST: 'PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_REQUEST',
    PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_SUCCESS: 'PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_SUCCESS',
    PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_ERROR: 'PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_ERROR',

    read: (id, cs, ct, dateTo) => ({
        type: actions.PUBLIC_STATEMENT_READ_REQUEST,
        id,
        cs,
        ct,
        dateTo,
    }),
    readV2: (statementId, hash, id, subdomain, dateFrom, dateTo) => ({
        type: actions.PUBLIC_STATEMENT_READ_V2_REQUEST,
        statementId,
        hash,
        id,
        subdomain,
        dateFrom,
        dateTo,
    }),
    resetState: () => ({
        type: actions.PUBLIC_STATEMENT_RESET_STATE,
    }),
    createPaymentStatement: request => ({
        type: actions.PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_REQUEST,
        request,
    }),
    createPayexPayment: (request, openInNewTab) => ({
        type: actions.PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_REQUEST,
        request,
        openInNewTab,
    }),
};
export default actions;
